module.exports = __webpack_public_path__ + "img/illustration_2.5fba3bc2.png";